import Range from "@/inside/models/Filter/Range";
import Switch from "@/inside/models/Filter/Switch";
import Operator from "@/inside/models/Filter/Operator";
import DateRange from "@/inside/models/Filter/DateRange";
import ExclusionSet from "@/inside/models/Filter/ExclusionSet";
import Action from "@/inside/models/Action/Action";

/**
 * @property {DateRange} actionDuePeriod
 * @property {ExclusionSet} actionPriority
 * @property {ExclusionSet} actionStatus
 * @property {ExclusionSet} actionTag
 * @property {ExclusionSet} assignmentAssessmentComplianceStatus
 * @property {ExclusionSet} assignmentAssessmentRelevanceStatus
 * @property {Switch} assignmentIsViewed
 * @property {DateRange} assignmentReassessmentDateRange
 * @property {ExclusionSet} requirementAssessmentComplianceStatus
 * @property {ExclusionSet} requirementAssessmentRelevanceStatus
 * @property {Switch} requirementBoundToActionStatus
 * @property {Switch} requirementRecentlyAmendedStatus
 * @property {Range} textAssessmentRate
 * @property {ExclusionSet} textbases
 * @property {Range} textComplianceRate
 * @property {Operator} textDatesOperator
 * @property {Switch} textEvent
 * @property {DateRange} textLastAmendmentDateRange
 * @property {Switch} textLocalStatus
 * @property {ExclusionSet} textSearch
 * @property {DateRange} textSignatureDateRange
 * @property {ExclusionSet} textTypes
 * @property {ExclusionSet} thematics
 */
export default class Store {
    constructor() {
        this.reset();
    }

    /**
     * Resets this store to its default state.
     * @return {Store}
     */
    reset() {
        this.actionDuePeriod = new DateRange();
        this.actionPriority = new ExclusionSet();
        this.actionStatus = new ExclusionSet().exclude(Action.statusClosed);
        this.actionTag = new ExclusionSet();
        this.assignmentAssessmentComplianceStatus = new ExclusionSet();
        this.assignmentAssessmentRelevanceStatus = new ExclusionSet();
        this.assignmentIsViewed = new Switch(["", "0", "1"], "");
        this.assignmentReassessmentDateRange = new DateRange();
        this.requirementAssessmentComplianceStatus = new ExclusionSet();
        this.requirementAssessmentRelevanceStatus = new ExclusionSet();
        this.requirementBoundToActionStatus = new Switch(["", "0", "1"], "");
        this.requirementRecentlyAmendedStatus = new Switch(["", "0", "1"], "");
        this.textAssessmentRate = (new Range()).set(0, 100);
        this.textbases = new ExclusionSet();
        this.textComplianceRate = (new Range()).set(0, 100);
        this.textDatesOperator = new Operator();
        this.textEvent = new Switch(["", "recently-added", "recently-amended", "both"], "");
        this.textLastAmendmentDateRange = new DateRange();
        this.textLocalStatus = new Switch(["", "0", "1"], "");
        this.textSearch = new ExclusionSet();
        this.textSignatureDateRange = new DateRange();
        this.textTypes = new ExclusionSet();
        this.thematics = new ExclusionSet();
        this.inputSearch = "";
        return this;
    }
}
